import React, { useState, useEffect } from 'react';
// BrowserRouter para URLs reais (indexáveis e com preview ao partilhar).
// Os 404 do GitHub Pages são tratados por public/404.html + o script em index.html.
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {
    Main,
    Timeline,
    Expertise,
    Project,
    Navigation,
    Footer,
} from './components';
import FadeIn from './components/FadeIn';
import Lantern from './components/Lantern';
import Writeups from './components/Writeups';
import WriteupPage from './components/WriteupPage';
import './index.scss';

function HomeContent() {
    return (
        <FadeIn transitionDuration={700}>
            <Main />
            <Expertise />
            <Timeline />
            <Project />
        </FadeIn>
    );
}

function App() {
    // Inicializa o modo com base no que está no sistema ou mantém dark
    const [mode, setMode] = useState<string>('dark');

    const handleModeChange = () => {
        setMode((m) => (m === 'dark' ? 'light' : 'dark'));
    };

    useEffect(() => {
        // Garante que a página começa no topo ao carregar
        window.scrollTo(0, 0);
    }, []);

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
            <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
                <Navigation parentToChild={{ mode }} modeChange={handleModeChange} />
                <Lantern mode={mode} />

                <div className="app-content">
                    <Routes>
                        <Route path="/" element={<HomeContent />} />
                        <Route path="/writeups" element={<Writeups />} />
                        {/* O ID do writeup será carregado corretamente aqui */}
                        <Route path="/writeups/:id" element={<WriteupPage />} />
                        
                        {/* Rota de fallback: se o utilizador escrever um URL errado, volta para a Home */}
                        <Route path="*" element={<HomeContent />} />
                    </Routes>
                </div>

                <Footer />
            </div>
        </BrowserRouter>
    );
}

export default App;